import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { FolderCloseTabRequestEvent } from 'src/app/models/events/folder-close-tab-request-event';
import { FolderRenameTabRequestEvent } from 'src/app/models/events/folder-rename-tab-request-event';

@Injectable({
    providedIn: 'root',
})
export class FolderTabEventsService {
    /**
     * Emis lorsque le dossier correspondant à l'onglet est fermé.
     */
    public closed = new Subject<FolderCloseTabRequestEvent>();

    /**
     * Emis lorsque le dossier correspondant à l'onglet est renommé.
     */
    public renamed = new Subject<FolderRenameTabRequestEvent>();
}
